module.exports = __webpack_public_path__ + "static/img/todayRankBg.56db32e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DiwaliFestival/todayRankBg.png
// module id = x61t
// module chunks = 0